import React, { useEffect } from 'react';
import ReactTooltip from 'react-tooltip';
import produce from 'immer';

import {
  Table,
  TableRow,
  TableCell,
  Pagination,
} from '@unimed-fesp/components';

import theme from '../../../styles/theme';

import { TableContentWrapper, ContentWrapper } from './styles';

import FadeIn from '../../atoms/FadeIn';

import TableDocumentosHeader from './TableDocumentosHeader';
import TableContent from './TableContent';

const DocumentosBeneficiarios = ({
  idLista,
  headers,
  filteredBeneficiarios,
  handleModalDetalheDocumento,

  pageData,
  paginationParams,
  handleChangePage,
  setPaginationParams,
  handlePageChangeKeyDown,
  hasPagination,
}) => {
  useEffect(() => {
    if (hasPagination) {
      const newPaginationParams = produce(paginationParams, (draft) => {
        draft.pageNumber = pageData.pageNumber;
        draft.pageSize = pageData.pageSize;
        draft.totalPages = pageData.total;

        return draft;
      });
      setPaginationParams(newPaginationParams);
    }
  }, [hasPagination, pageData, paginationParams, setPaginationParams]);

  return (
    <TableContentWrapper maxHeight="none" height="auto">
      <ContentWrapper>
        <FadeIn height="auto">
          <Table head={<TableDocumentosHeader header={headers} />}>
            {filteredBeneficiarios.map((beneficiario) => (
              <TableRow noWordBreak key={beneficiario?.id}>
                <TableCell>{beneficiario?.nome}</TableCell>
                <TableContent
                  idLista={idLista}
                  headers={headers}
                  handleModalDetalheDocumento={handleModalDetalheDocumento}
                  beneficiario={beneficiario}
                />
                <ReactTooltip
                  className="extraClass"
                  delayHide={false}
                  effect="solid"
                  backgroundColor={theme.greenHover}
                  textColor="#FFF"
                  place="bottom"
                />
              </TableRow>
            ))}
          </Table>
        </FadeIn>
      </ContentWrapper>
      {hasPagination && pageData.size > 10 && (
        <Pagination
          callbackChangePage={handleChangePage}
          setPaginationParams={setPaginationParams}
          paginationParams={paginationParams}
          total={pageData.size}
          handlePageChangeKeyDown={handlePageChangeKeyDown}
        />
      )}
    </TableContentWrapper>
  );
};

export default DocumentosBeneficiarios;
